import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TApiPaginatedResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualPoliciesWorkersRequestSchema,
  TGetAccrualPoliciesWorkersResponseSchema,
} from "./getAccrualPoliciesWorkers.schema";

export const getAccrualPoliciesWorkers = (axios: IAxiosInstance) => {
  return async ({ companyID }: TGetAccrualPoliciesWorkersRequestSchema) => {
    const { data } = await axios.noRetry.get<
      TApiPaginatedResponse<TGetAccrualPoliciesWorkersResponseSchema>
    >(`/accrual-policies/workers`, {
      params: { companyID },
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
